import { gql } from '@apollo/client';

// Fragment-only module (no component/heavy-lib imports) so the global fragment
// registry can import it without dragging VisitRequestActionsCell.tsx — and the
// decision-support tables it transitively reaches (@tanstack/react-table) — into
// the boot-time entry chunk. See Linear FE-831.
export const VisitRequestActionsCellFragment = gql`
    fragment VisitRequestActionsCellFragment on VisitRequest {
        id
        state
        visitRequestWorkflowStep: workflowStep
        permissions {
            id
            edit
        }
        visit {
            id
        }
        warnings {
            message
        }
    }
`;
